<template>
    <div class="flex items-center min-w-0 flex-shrink-0" :class="customClass">
        <div class="relative outline-hidden flex items-center flex-1">
            <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none outline-hidden z-10">
                <Search class="w-4 h-4" />
            </div>
            <Input
                :id="`${randomUIDBasedOnTime}-default-search`"
                v-model="searchQuery"
                type="search"
                :disabled="props.loading"
                class="pl-10"
                :placeholder="props.placeholder || 'Search...'" />
        </div>
        <LoadingButton
            v-if="enableRefresh"
            size="md"
            class="ml-1 flex-shrink-0 h-9"
            :is-loading="props.loading"
            :disabled="props.loading"
            :show-content-on-loading="false"
            @click="handleRefresh">
            <RefreshCwIcon class="h-4 w-4 text-primary-foreground dark:text-primary-foreground/70" />
        </LoadingButton>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Search, RefreshCwIcon } from 'lucide-vue-next';
import { Input } from '@/components/ui/input';
import { LoadingButton } from '@/components/ui/loading-button';

const props = defineProps({
    placeholder: {
        type: String,
        default: ''
    },
    loading: {
        type: Boolean,
        default: false
    },
    customClass: {
        type: String,
        default: 'w-80 min-w-80'
    },
    enableRefresh: {
        type: Boolean,
        default: false
    }
});
const emit = defineEmits(['search', 'refresh']);

const searchQuery = ref('');
const randomUIDBasedOnTime = new Date().getTime();

const handleRefresh = () => {
    emit('refresh');
};

watch(
    () => searchQuery.value,
    (newSearchQuery) => {
        emit('search', newSearchQuery);
    }
);
</script>
